export const GHQ_POLICIES_LINK =
  'https://anheuserbuschinbev.sharepoint.com/sites/ABIGlobalPolicies';
export const EUR_POLICIES_LINK =
  'https://anheuserbuschinbev.sharepoint.com/sites/zone-europe-legal/SitePages/Policies-and-Procedures.aspx';
export const GQH_CREATE_TICKET_LINK = 'https://abinbevww.service-now.com/abiex?id=sc_cat_item&sys_id=5ad2235adb1cc050f17eb29f29961934';
export const EUR_CREATE_TICKET_LINK = 'https://abinbevww.service-now.com/cheers?id=cheers_hub_cat_item&sys_id=5ad2235adb1cc050f17eb29f29961934'